import React, { useState } from 'react';
import { userApi } from '../services/api';
import { useAuth } from '../context/AuthContext';

export default function ChangePasswordModal({ onSuccess }) {
  const { user } = useAuth();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (newPassword.length < 6) { setError('Password must be at least 6 characters'); return; }
    if (newPassword !== confirmPassword) { setError('Passwords do not match'); return; }
    setLoading(true);
    try {
      await userApi.changePassword({ current_password: currentPassword, new_password: newPassword });
      onSuccess?.();
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to change password');
    } finally { setLoading(false); }
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center" style={{ backgroundColor: 'rgba(0,0,0,0.6)' }} data-testid="change-password-modal">
      <div className="rounded-xl p-6 w-full max-w-md shadow-2xl" style={{ backgroundColor: 'var(--card-bg)', color: 'var(--foreground)' }}>
        <div className="text-center mb-6">
          <div className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-3" style={{ backgroundColor: 'var(--primary)', color: '#fff' }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 256 256"><path d="M48,56V200a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0Zm92,54.5L120,117V40a8,8,0,0,0-16,0v77l-20-6.5a8,8,0,0,0-4.94,15.22l32,10.37a8,8,0,0,0,4.94-15.22Z"></path></svg>
          </div>
          <h2 className="text-xl font-bold" style={{ color: 'var(--text-heading)' }}>Change Your Password</h2>
          <p className="text-sm mt-1" style={{ color: 'var(--text-muted)' }}>
            {user?.must_change_password
              ? 'Your administrator requires you to change your password before continuing.'
              : 'Enter your current password and choose a new one.'}
          </p>
        </div>

        {error && <div className="p-2.5 rounded-lg text-sm mb-4" style={{ backgroundColor: 'rgba(255,51,51,0.1)', color: '#FF3333' }}>{error}</div>}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-xs font-medium mb-1" style={{ color: 'var(--text-secondary)' }}>Current Password</label>
            <input type="password" value={currentPassword} onChange={e => setCurrentPassword(e.target.value)} required
              className="w-full px-3 py-2.5 rounded-lg border text-sm" style={{ backgroundColor: 'var(--input-bg)', borderColor: 'var(--input-border)', color: 'var(--foreground)' }}
              placeholder="Enter current password" data-testid="current-password-input" />
          </div>
          <div>
            <label className="block text-xs font-medium mb-1" style={{ color: 'var(--text-secondary)' }}>New Password</label>
            <input type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)} required
              className="w-full px-3 py-2.5 rounded-lg border text-sm" style={{ backgroundColor: 'var(--input-bg)', borderColor: 'var(--input-border)', color: 'var(--foreground)' }}
              placeholder="At least 6 characters" data-testid="new-password-input" />
          </div>
          <div>
            <label className="block text-xs font-medium mb-1" style={{ color: 'var(--text-secondary)' }}>Confirm New Password</label>
            <input type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} required
              className="w-full px-3 py-2.5 rounded-lg border text-sm" style={{ backgroundColor: 'var(--input-bg)', borderColor: 'var(--input-border)', color: 'var(--foreground)' }}
              placeholder="Re-enter new password" data-testid="confirm-password-input" />
          </div>
          <button type="submit" disabled={loading}
            className="w-full py-2.5 rounded-lg text-sm font-semibold text-white transition-opacity disabled:opacity-50"
            style={{ backgroundColor: 'var(--primary)' }} data-testid="change-password-submit">
            {loading ? 'Changing...' : 'Change Password'}
          </button>
        </form>
      </div>
    </div>
  );
}
